(function () {
  window.battleService = {
    getQueue(data) {
      //return axios.get(`/api/battle/get.php${ data && data.battle ? '?active=true' : ''}`);
      return axios.get(`/api/battle/get.php`, data);
    },
    getActive(data) {
      return axios.get(`/api/battle/get.php?active=true`);
    },
    getAuto(data) {
      return axios.get(`/api/battle/get.php?auto=true`);
    },
    getStatus(id) {
      return axios.get(`/api/battle/status.php?id=${id}`);
    },
    save(data) {
      return axios.post('/api/battle/save.php', data);
    },
    test(data) {
      return axios.post('/api/battle/test.php', data);
    },
    challenge(data) {
      return axios.post('/api/battle/challenge.php', {
        user1TwitchId: data.fromId,
        user1TwitchDisplayName: data.fromUserName,
        user2TwitchDisplayName: data.atName,
        user1Cards: data.cards,
        faction: data.faction,
      });
    },
    accept(data) {
      return axios.post('/api/battle/accept.php', {
        user1TwitchDisplayName: data.atName,
        user2TwitchDisplayName: data.fromUserName,
        user2TwitchId: data.fromId,
        user2Cards: data.cards,
        faction: data.faction,
      });
    },
    decline(data) {
      return axios.post('/api/battle/decline.php', {
        user1TwitchDisplayName: data.atName,
        user2TwitchDisplayName: data.fromUserName,
      });
    },
    cancel(data) {
      return axios.post('/api/battle/cancel.php', data);
    },
    requeue(data) {
      return axios.post('/api/battle/queue.php', data);
    },
    challengeStreamer(data) {
      return axios.post('/api/team_battle/streamer-challenge.php', data);
    },
    acceptStreamer(data) {
      return axios.post('/api/team_battle/streamer-accept.php', data);
    },
    declineStreamer(data) {
      return axios.post('/api/battle/streamer-decline.php', data);
    },
    getRandomCardsByTier(data){
      return axios.post('/api/battle/bot-cards.php', data);
    },
    getQuest(data){
      return axios.post('/api/battle/get-quest.php', data);
    },
    getActiveTournament() {
      return axios.get(`/api/battle/get.php?active=true&&tournament=true`);
    },
    // joinTournament(data){
    //   return axios.post('/api/battle/get-quest.php', data);
    // },
  };
})();
